import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import ctaBtn from '../assets/img/get-in-touch.png';
import CommonModal from "../components/CommonModal";

const Header = () => {
    return ( 

       <>
       
       <CommonModal id="staticBackdrop" />
      
        
        <header>
            <div className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="navbar navbar-expand-md sticky-top">
                                <div className="flex-row-mbr">
                                    <a className="navbar-brand" href="/"><img src={logo} alt="" className='logom' /></a>
                                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                                        <span className='barsc'></span>
                                        <span className='barsc'></span>
                                        <span className='barsc'></span>
                                    </button>
                                    <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar"
                                        aria-labelledby="offcanvasNavbarLabel">
                                        <div className="offcanvas-header">
                                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Bhavana Singh</h5>
                                            <button type="button" className="btnclose" data-bs-dismiss="offcanvas"
                                                aria-label="Close">X</button>
                                        </div>
                                        <div className="offcanvas-body">
                                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/personality-development-courses ">Transform With Bhavana </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/one-on-one-transformation">Personality Transformation<br></br>(One-on-one)</a>
                                                </li>
                                                 <li className="nav-item">
                                                    <a className="nav-link" href="/styling-with-bhavna">Style with Bhavana </a>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a className="nav-link" href="/">Masterclass</a>
                                                </li> */}
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/about-us">About</a>
                                                </li>
                                                 <li className="nav-item">
                                                    <a className="nav-link" href="/blog">Blog</a>
                                                </li>
                                               
                                            </ul>
                                             <div className="d-none d-md-flex align-items-center">
                                                <a href="" data-bs-toggle="modal" data-bs-target="#staticBackdrop" className="header-cta">
                                                    Get in touch <img src={ctaBtn} alt="Get in Touch" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

         </>
    );
};

export default Header;
